<template>
  <div class="flex items-center gap-4">
    <NuxtLink
      v-if="isLink"
      :to="`/company/${permalink}`"
      class="flex items-center gap-4 hover:opacity-80 transition-opacity"
    >
      <img
        :src="logoUrl"
        :alt="name"
        width="48"
        height="48"
        class="w-12 h-12 object-contain rounded-lg shadow-sm"
        loading="lazy"
        decoding="async"
      >
      <span class="font-semibold text-gray-900 text-lg">{{ name }}</span>
    </NuxtLink>
    <div
      v-else
      class="flex items-center gap-4"
    >
      <img
        :src="logoUrl"
        :alt="name"
        width="48"
        height="48"
        class="w-12 h-12 object-contain rounded-lg shadow-sm"
        loading="lazy"
        decoding="async"
      >
      <span class="font-semibold text-gray-900 text-lg">{{ name }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  name: string
  logoUrl: string
  permalink?: string
  isLink?: boolean
}>()
</script>
